<div class="nav-bar" *ngIf="this.headerService.isHistoryTabsVisible()">
  <div class="top-container">
    @for(menuItem of historyTabs; track menuItem.content) {
    <button (click)="selectButton(menuItem.className)" class="button__item"
      [ngClass]="isButtonSelected(menuItem.className) ? 'selected' : 'not-selected'">
      {{menuItem.content}}
    </button>
    }
  </div>
</div>